/**
 * SHA1 (RFC 3174) legacy hash function.
 * @module
 * @deprecated
 */
import { SHA1 as SHA1n, sha1 as sha1n } from './legacy.ts';
/** @deprecated Use import from `noble/hashes/legacy` module */
export const SHA1: typeof SHA1n = SHA1n;
/** @deprecated Use import from `noble/hashes/legacy` module */
export const sha1: typeof sha1n = sha1n;
